import "./widgets-core18.css";
import { openBlock as b, createElementBlock as h, createElementVNode as A, inject as N, defineComponent as $, useCssVars as R, unref as s, computed as w, withModifiers as F, normalizeClass as V, createBlock as E } from "vue";
import { a as D, i as G, b as H, k as P, r as L } from "./chunks/key.BnZ-8sdC.js";
import { u as U } from "./chunks/useTheme.L4REnSCw.js";
import { _ as X } from "./chunks/_plugin-vue_export-helper.CHgC5LLL.js";
function _(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var y = function() {
  return D.Date.now();
}, q = /\s/;
function J(e) {
  for (var t = e.length; t-- && q.test(e.charAt(t)); )
    ;
  return t;
}
var Q = /^\s+/;
function Y(e) {
  return e && e.slice(0, J(e) + 1).replace(Q, "");
}
var Z = "[object Symbol]";
function K(e) {
  return typeof e == "symbol" || G(e) && H(e) == Z;
}
var M = NaN, ee = /^[-+]0x[0-9a-f]+$/i, te = /^0b[01]+$/i, ne = /^0o[0-7]+$/i, re = parseInt;
function S(e) {
  if (typeof e == "number")
    return e;
  if (K(e))
    return M;
  if (_(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = _(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = Y(e);
  var r = te.test(e);
  return r || ne.test(e) ? re(e.slice(2), r ? 2 : 8) : ee.test(e) ? M : +e;
}
var ie = "Expected a function", oe = Math.max, ae = Math.min;
function ce(e, t, r) {
  var a, u, m, f, i, o, l = 0, p = !1, c = !1, T = !0;
  if (typeof e != "function")
    throw new TypeError(ie);
  t = S(t) || 0, _(r) && (p = !!r.leading, c = "maxWait" in r, m = c ? oe(S(r.maxWait) || 0, t) : m, T = "trailing" in r ? !!r.trailing : T);
  function k(n) {
    var d = a, g = u;
    return a = u = void 0, l = n, f = e.apply(g, d), f;
  }
  function O(n) {
    return l = n, i = setTimeout(v, t), p ? k(n) : f;
  }
  function W(n) {
    var d = n - o, g = n - l, B = t - d;
    return c ? ae(B, m - g) : B;
  }
  function C(n) {
    var d = n - o, g = n - l;
    return o === void 0 || d >= t || d < 0 || c && g >= m;
  }
  function v() {
    var n = y();
    if (C(n))
      return I(n);
    i = setTimeout(v, W(n));
  }
  function I(n) {
    return i = void 0, T && a ? k(n) : (a = u = void 0, f);
  }
  function j() {
    i !== void 0 && clearTimeout(i), l = 0, a = o = u = i = void 0;
  }
  function z() {
    return i === void 0 ? f : I(y());
  }
  function x() {
    var n = y(), d = C(n);
    if (a = arguments, u = this, o = n, d) {
      if (i === void 0)
        return O(o);
      if (c)
        return clearTimeout(i), i = setTimeout(v, t), k(o);
    }
    return i === void 0 && (i = setTimeout(v, t)), f;
  }
  return x.cancel = j, x.flush = z, x;
}
function se(e, t) {
  return b(), h("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, [
    A("path", { d: "M10.707 10.5l5.646-5.646a.5.5 0 00-.707-.707L10 9.793 4.354 4.147a.5.5 0 00-.707.707L9.293 10.5l-5.646 5.646a.5.5 0 00.708.707l5.646-5.646 5.646 5.646a.498.498 0 00.708 0 .5.5 0 000-.707L10.709 10.5z" })
  ]);
}
function ue(e, t) {
  return b(), h("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, [
    A("path", { d: "M14 20a.5.5 0 00.354-.853l-8.646-8.646 8.646-8.646a.5.5 0 00-.707-.707l-9 9a.5.5 0 000 .707l9 9a.498.498 0 00.354.146z" })
  ]);
}
const fe = () => N(P, {
  t: (t, r) => L(t, r) || t,
  tc: (t, r, a) => L(t, a) || t
}), le = ["aria-label"], de = /* @__PURE__ */ $({
  __name: "ActionButton",
  props: {
    type: { default: "close" },
    color: {},
    overColor: {},
    size: { default: "medium" }
  },
  emits: ["action-click"],
  setup(e, { emit: t }) {
    R((l) => ({
      "7f1e9edf": f.value,
      "4c978f2a": i.value,
      "5b628c32": s(u).borderRadius
    }));
    const r = e, a = t, u = U(), { t: m } = fe(), f = w(() => r.color ?? "#333"), i = w(() => r.overColor ?? u.actionColor.base), o = ce(() => {
      a("action-click");
    }, 200, { leading: !0, trailing: !1 });
    return (l, p) => (b(), h("button", {
      type: "button",
      onMousedown: p[0] || (p[0] = F(
        //@ts-ignore
        (...c) => s(o) && s(o)(...c),
        ["left"]
      )),
      onClick: p[1] || (p[1] = //@ts-ignore
      (...c) => s(o) && s(o)(...c)),
      "data-testid": "action-trigger",
      "aria-label": r.type === "close" ? s(m)("Close") : s(m)("Back"),
      class: V(["actionTrigger", `actionTrigger--${r.size}`])
    }, [
      l.type === "close" ? (b(), E(s(se), {
        key: 0,
        class: "actionTrigger__icon close"
      })) : (b(), E(s(ue), {
        key: 1,
        class: "actionTrigger__icon back"
      }))
    ], 42, le));
  }
}), Te = /* @__PURE__ */ X(de, [["__scopeId", "data-v-dff25ba4"]]);
export {
  Te as default,
  fe as u
};
//# sourceMappingURL=widgets-core.es20.js.map
